import { apiCall } from '@/util/apiCall'
import type { Disruption } from '@common/types/Disruption'
import { setDisruptions } from '../disruptions'
import { makeTracker } from './track'

export const trackDisruptions = makeTracker({
	id: () => `disruptions`,
	loader: async api => {
		const { data: disruptions } = await apiCall<{ data: Disruption[] }>(
			'/disruptions',
			{
				signal: api.signal,
				cache: 'no-cache',
			},
		)
		return setDisruptions(disruptions)
	},
})
